import config from '@config';

export const downloadImage = async (imageUrl?: string): Promise<boolean> => {
  try {
    if (!imageUrl) {
      throw new Error('이미지 url이 존재하지 않음');
    }

    const replacedImageUrl = imageUrl.replace(
      config.CLOUDFRONT_DISTRIBUTION_URL ?? '',
      config.CLOUDFRONT_ALTERNATE_URL ?? ''
    );

    const response = await fetch(replacedImageUrl, {
      method: 'GET',
      credentials: 'include'
    });

    if (!response.ok) throw new Error('이미지 다운로드 실패');

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'refa_image';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error('이미지 다운로드 실패:', error);
    return false;
  }
};
